var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.14646C0 0.961005 0.93016 0 2.07757 0C3.22498 0 4.15514 0.961005 4.15514 2.14646C4.15514 3.33192 3.22498 4.29293 2.07757 4.29293C0.93016 4.29293 0 3.33192 0 2.14646Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 7.31454 0.93016 6.35354 2.07757 6.35354C3.22498 6.35354 4.15514 7.31454 4.15514 8.5C4.15514 9.68546 3.22498 10.6465 2.07757 10.6465C0.93016 10.6465 0 9.68546 0 8.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.8535C0 13.6681 0.93016 12.7071 2.07757 12.7071C3.22498 12.7071 4.15514 13.6681 4.15514 14.8535C4.15514 16.039 3.22498 17 2.07757 17C0.93016 17 0 16.039 0 14.8535Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84486 2.14646C6.84486 0.961005 7.77502 0 8.92243 0C10.0698 0 11 0.961005 11 2.14646C11 3.33192 10.0698 4.29293 8.92243 4.29293C7.77502 4.29293 6.84486 3.33192 6.84486 2.14646Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84486 8.5C6.84486 7.31454 7.77502 6.35354 8.92243 6.35354C10.0698 6.35354 11 7.31454 11 8.5C11 9.68546 10.0698 10.6465 8.92243 10.6465C7.77502 10.6465 6.84486 9.68546 6.84486 8.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84486 14.8535C6.84486 13.6681 7.77502 12.7071 8.92243 12.7071C10.0698 12.7071 11 13.6681 11 14.8535C11 16.039 10.0698 17 8.92243 17C7.77502 17 6.84486 16.039 6.84486 14.8535Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.9caa3507cfe49d9e31dbd6072cee7b9d.svg";
export { ForwardRef as ReactComponent };